export default __webpack_public_path__ + "static/media/WSUD Training.30c03e4a.jpg";